import { createWorkerAction } from '../lib';

export const performanceApplicationLoaded = createWorkerAction(
  'PERFORMANCE_APPLICATION_LOADED',
);
